var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.rank)?_c('div',{staticClass:"baseTagSquare",class:_vm.score},[_vm._v(_vm._s(_vm.scoreData))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }